import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountPPICloseSuccessPage} from 'features/loans/pages/LoanAccountPPIClosePage/LoanAccountPPICloseSuccessPage';

export const Route = createFileRoute(
  '/_protected/accounts/loans/$accountId/ppi/close/success',
)({
  component: LoanAccountPPICloseSuccessPage,
});
